import formatRut from "./formatRut";
export const swtichOnChange = () => {
  return formatRut;
};

export default swtichOnChange;
